import {atom} from "recoil";

/**
 * 결재 수신함 문서 상태
 * @type {RecoilState<number>}
 */
export const receiveDocTotalCount = atom({
    key: "receiveDocTotalCount"
    , default: 0
})